/**
 * 供应商合同服务类型相关常量
 *
 * 合同域 service_type 统一复用 settlement 的 STANDARD_COST_TYPE（23 个标准费用类型），
 * 与后端 CostType 枚举、账单 cost_type 完全一致，消除映射层歧义。
 * 三币种模型设计契约 doc 60 §3.4: 合同 service_type 与账单 cost_type 同名。
 */

import {
    STANDARD_COST_TYPE,
    STANDARD_COST_TYPE_LABELS,
    STANDARD_COST_TYPE_COLORS,
    STANDARD_COST_TYPE_OPTIONS,
} from "../../../settlement/constants";

// 服务类型枚举（复用 CostType 23 项）
export const SERVICE_TYPES = STANDARD_COST_TYPE;

// 服务类型显示映射（复用 settlement 标签）
export const SERVICE_TYPE_LABELS = STANDARD_COST_TYPE_LABELS;

// 服务类型颜色映射（复用 settlement 颜色）
export const SERVICE_TYPE_COLORS = STANDARD_COST_TYPE_COLORS;

// 服务类型完整映射（包含文本和颜色，供 Tag 渲染）
export const SERVICE_TYPE_MAP = Object.keys(STANDARD_COST_TYPE).reduce((map, key) => {
    const value = STANDARD_COST_TYPE[key];
    map[value] = {
        text: STANDARD_COST_TYPE_LABELS[value] || value,
        color: STANDARD_COST_TYPE_COLORS[value] || "default",
    };
    return map;
}, {});

// 表单选项（复用 settlement 选项）
export const SERVICE_TYPE_OPTIONS = STANDARD_COST_TYPE_OPTIONS;
